import { configure, extend, localize, ValidationObserver, ValidationProvider } from 'vee-validate';
import ptBR from 'vee-validate/dist/locale/pt_BR.json';
import { email, max, min, min_value, required } from 'vee-validate/dist/rules';
import Vue from 'vue';

import CPFValidator from './cpf-validator';
import DateFormatValidator from './date-format-validator';
import isUrl from './url';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

configure({
  classes: {
    invalid: 'is-invalid',
  },
});

extend('required', required);
extend('email', email);
extend('min', min);
extend('max', max);
extend('min_value', min_value);

extend('url', {
  validate: isUrl,
  message: 'O campo {_field_} deve ser uma URL válida',
});

extend('date_format', {
  validate: (value: string, args: any) => DateFormatValidator.isValid(value, args),
  message: 'Informa uma data válida.',
});
extend('cpf', {
  validate: (value: any) => CPFValidator.isValid(value),
  message: 'Informe um CPF válido.',
});
localize('pt_BR', ptBR);
